var map = {
	"./43_banana.mp3": "e988",
	"./44_pear.mp3": "fa24",
	"./45_cherry.mp3": "8331",
	"./46_lemon.mp3": "793a",
	"./47_pepper.mp3": "7c7b",
	"./48_carrot.mp3": "4017",
	"./49_tomato.mp3": "9cdb",
	"./50_dog.mp3": "ce0c",
	"./51_cat.mp3": "5dad",
	"./52_mouse.mp3": "1735",
	"./53_fish.mp3": "249d",
	"./54_hamster.mp3": "8687",
	"./55_parrot.mp3": "be353",
	"./56_canary.mp3": "bfee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a832";